<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">系统管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>人员包片管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="用户姓名">
                <el-select
                  placeholder="用户姓名"
                  clearable
                  filterable
                  v-model="form.userId"
                >
                  <el-option
                    v-for="item in userListOptions"
                    :key="item.id"
                    :label="item.userName + '(' + item.deptName + ')'"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="管辖部门">
                <el-select
                  placeholder="管辖部门"
                  clearable
                  v-model="form.deptId"
                >
                  <el-option
                    v-for="item in deptIdsOptions"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="科室部门">
                <el-select
                  style="width: 356px"
                  v-model="form.ksDeptId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in deptList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="configPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import { getPointLevelListPage, configPage } from "@/api/point.js";
import { getUserList2, getDeptTree } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    addDialog,
    commonTable
  },
  data() {
    return {
      form: {
        userId: "",
        deptId: "",
        ksDeptId: ""
      },
      userListOptions: [],
      deptIdsOptions: [],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "userName",
            label: "用户名"
          },
          {
            prop: "ksDeptName",
            label: "科室部门"
          },
          {
            prop: "deptName",
            label: "管辖部门"
          }
        ]
      },
      curItem: {},
      deptList: []
    };
  },
  mounted() {
    this.configPageFun();
    this.getUserList2PageFun();
    this.getPointLevelListPageFun();
    this.getTree();
  },
  methods: {
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: 1,
        size: 99999,
        levelCode: 2
      };
      const res = await getPointLevelListPage(params);
      this.deptIdsOptions = res.data.data.records || [];
    },
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.configPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.configPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.configPageFun();
    },
    onReset() {
      this.form.deptId = "";
      this.form.userId = "";
      this.form.ksDeptId = "";
      this.page.page = 1;
      this.page.size = 10;
      this.configPageFun();
    },
    // 人员
    async getUserList2PageFun() {
      const res = await getUserList2({
        enableStatus: 0,
        page: 1,
        size: 9999,
        zcUserTypeLike: "gov"
      });
      this.userListOptions = res.data.data.dataList;
    },
    // 分页查询
    async configPageFun() {
      let params = {
        userId: this.form.userId,
        deptId: this.form.deptId,
        ksDeptId: this.form.ksDeptId,
        page: this.page.page,
        size: this.page.size
      };
      const res = await configPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/personBp/index.vue